import { useEffect, useState } from "react";
import {
  ACC,
  Container,
  JobItem,
  MenuOptions,
  Option,
  RetractButton,
  Sections,
  ULJobs,
} from "./styles";
import { ToggleButton } from "../../../components/general/ToggleButton";
import { FocusIcon } from "../../../assets/icons/Focus";
import { useZoomPanHelper, useStore } from "react-flow-renderer";
import { toastAlert } from "../../../components/Toastify";
import PushBackIcon from "../../../assets/icons/PushBackIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  changeJobstoACC,
  changeJobstoAll,
  closeJobsMenu,
  openJobsMenu,
} from "../../../state/zaivuPersist/slice";

const getJobsByStatus = (jobs, acc, userId) => {
  const accJobs = acc
    ? jobs.filter((j) => j.accountable?.userId === userId)
    : jobs;

  return {
    momentJobs: accJobs.filter(
      (j) => j.status === "doing" || j.status === "late",
    ),
    doneJobs: accJobs.filter(
      (j) => j.status === "done" || j.status === "doneLate",
    ),
    pendingJobs: accJobs.filter((j) => j.status === "pending"),
  };
};

const useSwitchSection = (defaultSection, optionsObject) => {
  const [current, setCurrent] = useState(defaultSection);

  const [options, setOptions] = useState(optionsObject);

  useEffect(() => {
    const updatedOptions = {};
    for (const key in options) {
      updatedOptions[key] = key === current;
    }
    setOptions(updatedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  return [options, setCurrent];
};

const verifyJobPermissions = (job, setOpen, user) => {
  const rank = user.rank;
  const userId = user._id;
  const acc = job.accountable;

  if (acc?.userId === userId || rank === "admin" || rank === "gerente") {
    setOpen({ id: job.id, isOpen: true });
  } else {
    toastAlert({ msg: "Acesso Negado.", isError: true });
  }
};

const ListingJobs = ({ jobs, setOpen, focus, user }) =>
  jobs.map((j) => (
    <JobItem key={Math.random()} status={j.status}>
      <FocusIcon
        onClick={() => focus(j.id)}
        style={{
          height: "1.5rem",
          width: "2rem",
        }}
      />
      <button onClick={() => verifyJobPermissions(j, setOpen, user)}>
        {j.label}
      </button>
    </JobItem>
  ));

export const Accountable = ({ acc }) => {
  const dispatch = useDispatch();

  return (
    <ACC>
      <span style={{ color: "#7e858f" }}>Responsabilidade</span>
      <ToggleButton
        style={{
          marginLeft: "0.8rem",
          marginTop: "0.2rem",
        }}
        option={acc}
        changeOption={() => {
          if (acc) {
            dispatch(changeJobstoAll());
          } else {
            dispatch(changeJobstoACC());
          }
        }}
        width="25px"
        height="16px"
        label={acc ? "Minhas Tarefas" : "Todas as Tarefas"}
        labelColor={acc ? "#49b446" : "#111"}
      />
    </ACC>
  );
};

const FlowOptions = ({ visibility, options }) => {
  const [menuOptions, setMenuOptions] = options;
  const { markers, outscoped } = visibility;

  return (
    <MenuOptions
      style={{
        visibility:
          markers.length === 0 && outscoped.length === 0 ? "hidden" : "visible",
      }}
    >
      {markers.length > 0 ? (
        <ToggleButton
          style={{ marginBottom: "10px" }}
          option={menuOptions.markers}
          changeOption={() =>
            setMenuOptions({
              ...menuOptions,
              markers: !menuOptions.markers,
            })
          }
          width="30px"
          height="16px"
          label="Marcadores"
        />
      ) : null}

      {outscoped.length > 0 ? (
        <ToggleButton
          option={menuOptions.outscoped}
          changeOption={() =>
            setMenuOptions({
              ...menuOptions,
              outscoped: !menuOptions.outscoped,
            })
          }
          width="30px"
          height="16px"
          label="Fora de escopo"
        />
      ) : null}
    </MenuOptions>
  );
};

export function JobsBar({ jobs, user, modal, options, visibility }) {
  const dispatch = useDispatch();

  const ganttPersist = useSelector((state) => state.zaivuPersist.gantt);
  const { jobsACC: ACC, jobsMenuRetract: retract } = ganttPersist;

  const [jobSections, setJobSection] = useSwitchSection("jobsMenu", {
    jobsMenu: true,
    extraMenu: false,
  });

  const [taskSections, setTaskSection] = useSwitchSection("doing", {
    doing: true,
    done: false,
    pending: false,
  });

  const pushBackStyle = {
    height: "1.3rem",
    width: "1.3rem",
    cursor: "pointer",
  };

  const userId = user._id;

  const tasks = jobs.filter((j) => j.type === "task");
  const { momentJobs, doneJobs, pendingJobs } = getJobsByStatus(
    tasks,
    ACC,
    userId,
  );
  const jobsToList = taskSections.doing
    ? momentJobs
    : taskSections.pending
      ? pendingJobs
      : doneJobs;
  const [, setOpen] = modal;

  const store = useStore();

  const flowOptionsConditions =
    visibility.markers.length > 0 || visibility.outscoped.length > 0
      ? true
      : false;

  const focusNode = (id) => {
    const { nodes } = store.getState();

    const thisNode = nodes.find((n) => n.id === id);

    if (thisNode) {
      const node = thisNode;

      const x = node.__rf.position.x + node.__rf.width / 2;
      const y = node.__rf.position.y + node.__rf.height / 2;
      const zoom = 1.2;

      setCenter(x, y, zoom);
    }
  };
  const { setCenter } = useZoomPanHelper();

  return (
    <Container retract={retract}>
      <Sections>
        <Option
          active={jobSections.jobsMenu}
          onClick={() => setJobSection("jobsMenu")}
        >
          Tarefas do Fluxo
        </Option>

        <Option
          disable={!flowOptionsConditions}
          active={jobSections.extraMenu}
          onClick={() => setJobSection("extraMenu")}
        >
          Opções de Fluxo
        </Option>
      </Sections>

      {jobSections.jobsMenu ? (
        <>
          <Accountable acc={ACC} />
          <Sections>
            <Option
              colorActive="#118052"
              active={taskSections.doing}
              onClick={() => setTaskSection("doing")}
            >
              Execução
            </Option>
            <Option
              colorActive="#118052"
              active={taskSections.pending}
              onClick={() => setTaskSection("pending")}
            >
              Pendente
            </Option>
            <Option
              colorActive="#118052"
              active={taskSections.done}
              onClick={() => setTaskSection("done")}
            >
              Concluído
            </Option>
          </Sections>
          <ULJobs>
            {jobsToList.length > 0 ? (
              <ListingJobs
                jobs={jobsToList}
                setOpen={setOpen}
                focus={focusNode}
                user={user}
              />
            ) : (
              <span
                style={{
                  display: "block",
                  textAlign: "center",
                  color: "#585E66",
                  fontSize: "1rem",
                }}
              >
                Sem tarefas no momento!
              </span>
            )}
          </ULJobs>
        </>
      ) : jobSections.extraMenu ? (
        <FlowOptions visibility={visibility} options={options} />
      ) : null}

      <RetractButton
        retract={retract}
        onClick={() => {
          if (retract) {
            dispatch(closeJobsMenu());
          } else {
            dispatch(openJobsMenu());
          }
        }}
      >
        <PushBackIcon stroke="#585e66" style={pushBackStyle} />
      </RetractButton>
    </Container>
  );
}

